window.slate = window.slate || {};
window.theme = window.theme || {};

/*================ Slate ================*/
/**
 * A11y Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help make your theme more accessible
 * to users with visual impairments.
 *
 *
 * @namespace a11y
 */

slate.a11y = {

  /**
   * For use when focus shifts to a container rather than a link
   * eg for In-page links, after scroll, focus shifts to content area so that
   * next `tab` is where user expects if focusing a link, just $link.focus();
   *
   * @param {JQuery} $element - The element to be acted upon
   */
  pageLinkFocus: function($element) {
    var focusClass = 'js-focus-hidden';

    $element.first()
      .attr('tabIndex', '-1')
      .focus()
      .addClass(focusClass)
      .one('blur', callback);

    function callback() {
      $element.first()
        .removeClass(focusClass)
        .removeAttr('tabindex');
    }
  },

  /**
   * If there's a hash in the url, focus the appropriate element
   */
  focusHash: function() {
    var hash = window.location.hash;

    // is there a hash in the url? is it an element on the page?
    if (hash && document.getElementById(hash.slice(1))) {
      this.pageLinkFocus($(hash));
    }
  },

  /**
   * When an in-page (url w/hash) link is clicked, focus the appropriate element
   */
  bindInPageLinks: function() {
    $('a[href*=#]').on('click', function(evt) {
      this.pageLinkFocus($(evt.currentTarget.hash));
    }.bind(this));
  },

  /**
   * Traps the focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {jQuery} options.$elementToFocus - Element to be focused when focus leaves container
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  trapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (!options.$elementToFocus) {
      options.$elementToFocus = options.$container;
    }

    options.$container.attr('tabindex', '-1');
    options.$elementToFocus.focus();

    $(document).on(eventName, function(evt) {
      if (options.$container[0] !== evt.target && !options.$container.has(evt.target).length) {
        options.$container.focus();
      }
    });
  },

  /**
   * Removes the trap of focus in a particular container
   *
   * @param {object} options - Options to be used
   * @param {jQuery} options.$container - Container to trap focus within
   * @param {string} options.namespace - Namespace used for new focus event handler
   */
  removeTrapFocus: function(options) {
    var eventName = options.namespace
      ? 'focusin.' + options.namespace
      : 'focusin';

    if (options.$container && options.$container.length) {
      options.$container.removeAttr('tabindex');
    }

    $(document).off(eventName);
  }
};

/**
 * Cart Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Cart template.
 *
 * @namespace cart
 */

slate.cart = {

  /**
   * Browser cookies are required to use the cart. This function checks if
   * cookies are enabled in the browser.
   */
  cookiesEnabled: function() {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled){
      document.cookie = 'testcookie';
      cookieEnabled = (document.cookie.indexOf('testcookie') !== -1);
    }
    return cookieEnabled;
  }
};

/**
 * Utility helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions for dealing with arrays and objects
 *
 * @namespace utils
 */

slate.utils = {

  /**
   * Return an object from an array of objects that matches the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  findInstance: function(array, key, value) {
    for (var i = 0; i < array.length; i++) {
      if (array[i][key] === value) {
        return array[i];
      }
    }
  },

  /**
   * Remove an object from an array of objects by matching the provided key and value
   *
   * @param {array} array - Array of objects
   * @param {string} key - Key to match the value against
   * @param {string} value - Value to get match of
   */
  removeInstance: function(array, key, value) {
    var i = array.length;
    while(i--) {
      if (array[i][key] === value) {
        array.splice(i, 1);
        break;
      }
    }

    return array;
  },

  /**
   * _.compact from lodash
   * Remove empty/false items from array
   * Source: https://github.com/lodash/lodash/blob/master/compact.js
   *
   * @param {array} array
   */
  compact: function(array) {
    var index = -1;
    var length = array == null ? 0 : array.length;
    var resIndex = 0;
    var result = [];

    while (++index < length) {
      var value = array[index];
      if (value) {
        result[resIndex++] = value;
      }
    }
    return result;
  },

  /**
   * _.defaultTo from lodash
   * Checks `value` to determine whether a default value should be returned in
   * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
   * or `undefined`.
   * Source: https://github.com/lodash/lodash/blob/master/defaultTo.js
   *
   * @param {*} value - Value to check
   * @param {*} defaultValue - Default value
   * @returns {*} - Returns the resolved value
   */
  defaultTo: function(value, defaultValue) {
    return (value == null || value !== value) ? defaultValue : value
  }
};

/**
 * Rich Text Editor
 * -----------------------------------------------------------------------------
 * Wrap iframes and tables in div tags to force responsive/scrollable layout.
 *
 * @namespace rte
 */

slate.rte = {
  /**
   * Wrap tables in a container div to make them scrollable when needed
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$tables - jquery object(s) of the table(s) to wrap
   * @param {string} options.tableWrapperClass - table wrapper class name
   */
  wrapTable: function(options) {
    var tableWrapperClass = typeof options.tableWrapperClass === "undefined" ? '' : options.tableWrapperClass;

    options.$tables.wrap('<div class="' + tableWrapperClass + '"></div>');
  },

  /**
   * Wrap iframes in a container div to make them responsive
   *
   * @param {object} options - Options to be used
   * @param {jquery} options.$iframes - jquery object(s) of the iframe(s) to wrap
   * @param {string} options.iframeWrapperClass - class name used on the wrapping div
   */
  wrapIframe: function(options) {
    var iframeWrapperClass = typeof options.iframeWrapperClass === "undefined" ? '' : options.iframeWrapperClass;

    options.$iframes.each(function() {
      // Add wrapper to make video responsive
      $(this).wrap('<div class="' + iframeWrapperClass + '"></div>');

      // Re-set the src attribute on each iframe after page load
      // for Chrome's "incorrect iFrame content on 'back'" bug.
      // https://code.google.com/p/chromium/issues/detail?id=395791
      // Need to specifically target video and admin bar
      this.src = this.src;
    });
  }
};

slate.Sections = function Sections() {
  this.constructors = {};
  this.instances = [];

  $(document)
    .on('shopify:section:load', this._onSectionLoad.bind(this))
    .on('shopify:section:unload', this._onSectionUnload.bind(this))
    .on('shopify:section:select', this._onSelect.bind(this))
    .on('shopify:section:deselect', this._onDeselect.bind(this))
    .on('shopify:section:reorder', this._onReorder.bind(this))
    .on('shopify:block:select', this._onBlockSelect.bind(this))
    .on('shopify:block:deselect', this._onBlockDeselect.bind(this));
};

slate.Sections.prototype = $.extend({}, slate.Sections.prototype, {
  _createInstance: function(container, constructor) {
    var $container = $(container);
    var id = $container.attr('data-section-id');
    var type = $container.attr('data-section-type');

    constructor = constructor || this.constructors[type];

    if (typeof constructor === 'undefined') {
      return;
    }

    var instance = $.extend(new constructor(container), {
      id: id,
      type: type,
      container: container
    });

    this.instances.push(instance);
  },

  _onSectionLoad: function(evt) {
    var container = $('[data-section-id]', evt.target)[0];
    if (container) {
      this._createInstance(container);
    }
  },

  _onSectionUnload: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (!instance) {
      return;
    }

    if (typeof instance.onUnload === 'function') {
      instance.onUnload(evt);
    }

    this.instances = slate.utils.removeInstance(this.instances, 'id', evt.detail.sectionId);
  },

  _onSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onSelect === 'function') {
      instance.onSelect(evt);
    }
  },

  _onDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onDeselect === 'function') {
      instance.onDeselect(evt);
    }
  },

  _onReorder: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onReorder === 'function') {
      instance.onReorder(evt);
    }
  },

  _onBlockSelect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockSelect === 'function') {
      instance.onBlockSelect(evt);
    }
  },

  _onBlockDeselect: function(evt) {
    var instance = slate.utils.findInstance(this.instances, 'id', evt.detail.sectionId);

    if (instance && typeof instance.onBlockDeselect === 'function') {
      instance.onBlockDeselect(evt);
    }
  },

  register: function(type, constructor) {
    this.constructors[type] = constructor;

    $('[data-section-type=' + type + ']').each(function(index, container) {
      this._createInstance(container, constructor);
    }.bind(this));
  }
});

/**
 * Currency Helpers
 * -----------------------------------------------------------------------------
 * A collection of useful functions that help with currency formatting
 *
 * Current contents
 * - formatMoney - Takes an amount in cents and returns it as a formatted dollar value.
 *
 */

slate.Currency = (function() {
  var moneyFormat = '${{amount}}';

  /**
   * Format money values based on your shop currency settings
   * @param  {Number|string} cents - value in cents or dollar amount e.g. 300 cents
   * or 3.00 dollars
   * @param  {String} format - shop money_format setting
   * @return {String} value - formatted value
   */
  function formatMoney(cents, format) {
    if (typeof cents === 'string') {
      cents = cents.replace('.', '');
    }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || moneyFormat);

    function formatWithDelimiters(number, precision, thousands, decimal) {
      precision = slate.utils.defaultTo(precision, 2);
      thousands = slate.utils.defaultTo(thousands, ',');
      decimal = slate.utils.defaultTo(decimal, '.');

      if (isNaN(number) || number == null) {
        return 0;
      }

      number = (number / 100.0).toFixed(precision);

      var parts = number.split('.');
      var dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands);
      var centsAmount = parts[1] ? (decimal + parts[1]) : '';

      return dollarsAmount + centsAmount;
    }

    switch (formatString.match(placeholderRegex)[1]) {
      case 'amount':
        value = formatWithDelimiters(cents, 2);
        break;
      case 'amount_no_decimals':
        value = formatWithDelimiters(cents, 0);
        break;
      case 'amount_with_space_separator':
        value = formatWithDelimiters(cents, 2, ' ', '.');
        break;
      case 'amount_no_decimals_with_comma_separator':
        value = formatWithDelimiters(cents, 0, ',', '.');
        break;
      case 'amount_no_decimals_with_space_separator':
        value = formatWithDelimiters(cents, 0, ' ');
        break;
    }

    return formatString.replace(placeholderRegex, value);
  }

  return {
    formatMoney: formatMoney
  };
})();

/**
 * Image Helper Functions
 * -----------------------------------------------------------------------------
 * A collection of functions that help with basic image operations.
 *
 */

slate.Image = (function() {

  /**
   * Preloads an image in memory and uses the browsers cache to store it until needed.
   *
   * @param {Array} images - A list of image urls
   * @param {String} size - A shopify image size attribute
   */

  function preload(images, size) {
    if (typeof images === 'string') {
      images = [images];
    }

    for (var i = 0; i < images.length; i++) {
      var image = images[i];
      this.loadImage(this.getSizedImageUrl(image, size));
    }
  }

  /**
   * Loads and caches an image in the browsers cache.
   * @param {string} path - An image url
   */
  function loadImage(path) {
    new Image().src = path;
  }

  /**
   * Find the Shopify image attribute size
   *
   * @param {string} src
   * @returns {null}
   */
  function imageSize(src) {
    var match = src.match(/.+_((?:pico|icon|thumb|small|compact|medium|large|grande)|\d{1,4}x\d{0,4}|x\d{1,4})[_\.@]/);

    if (match) {
      return match[1];
    } else {
      return null;
    }
  }

  /**
   * Adds a Shopify size attribute to a URL
   *
   * @param src
   * @param size
   * @returns {*}
   */
  function getSizedImageUrl(src, size) {
    if (size === null) {
      return src;
    }

    if (size === 'master') {
      return this.removeProtocol(src);
    }

    var match = src.match(/\.(jpg|jpeg|gif|png|bmp|bitmap|tiff|tif)(\?v=\d+)?$/i);

    if (match) {
      var prefix = src.split(match[0]);
      var suffix = match[0];

      return this.removeProtocol(prefix[0] + '_' + size + suffix);
    } else {
      return null;
    }
  }

  function removeProtocol(path) {
    return path.replace(/http(s)?:/, '');
  }

  return {
    preload: preload,
    loadImage: loadImage,
    imageSize: imageSize,
    getSizedImageUrl: getSizedImageUrl,
    removeProtocol: removeProtocol
  };
})();

/**
 * Variant Selection scripts
 * ------------------------------------------------------------------------------
 *
 * Handles change events from the variant inputs in any `cart/add` forms that may
 * exist. Also updates the master select and triggers updates when the variants
 * price or image changes.
 *
 * @namespace variants
 */

slate.Variants = (function() {

  /**
   * Variant constructor
   *
   * @param {object} options - Settings from `product.js`
   */
  function Variants(options) {
    this.$container = options.$container;
    this.product = options.product;
    this.singleOptionSelector = options.singleOptionSelector;
    this.originalSelectorId = options.originalSelectorId;
    this.enableHistoryState = options.enableHistoryState;
    this.currentVariant = this._getVariantFromOptions();

    $(this.singleOptionSelector, this.$container).on('change', this._onSelectChange.bind(this));
  }

  Variants.prototype = $.extend({}, Variants.prototype, {

    /**
     * Get the currently selected options from add-to-cart form. Works with all
     * form input elements.
     *
     * @return {array} options - Values of currently selected variants
     */
    _getCurrentOptions: function() {
      var currentOptions = $.map($(this.singleOptionSelector, this.$container), function(element) {
        var $element = $(element);
        var type = $element.attr('type');
        var currentOption = {};

        if (type === 'radio' || type === 'checkbox') {
          if ($element[0].checked) {
            currentOption.value = $element.val();
            currentOption.index = $element.data('index');

            return currentOption;
          } else {
            return false;
          }
        } else {
          currentOption.value = $element.val();
          currentOption.index = $element.data('index');

          return currentOption;
        }
      });

      // remove any unchecked input values if using radio buttons or checkboxes
      currentOptions = slate.utils.compact(currentOptions);

      return currentOptions;
    },

    /**
     * Find variant based on selected values.
     *
     * @param  {array} selectedValues - Values of variant inputs
     * @return {object || undefined} found - Variant object from product.variants
     */
    _getVariantFromOptions: function() {
      var selectedValues = this._getCurrentOptions();
      var variants = this.product.variants;
      var found = false;

      variants.forEach(function(variant) {
        var satisfied = true;

        selectedValues.forEach(function(option) {
          if (satisfied) {
            satisfied = (option.value === variant[option.index]);
          }
        });

        if (satisfied) {
          found = variant;
        }
      });

      return found || null;
    },

    /**
     * Event handler for when a variant input changes.
     */
    _onSelectChange: function() {
      var variant = this._getVariantFromOptions();

      this.$container.trigger({
        type: 'variantChange',
        variant: variant
      });

      if (!variant) {
        return;
      }

      this._updateMasterSelect(variant);
      this._updateImages(variant);
      this._updatePrice(variant);
      this.currentVariant = variant;

      if (this.enableHistoryState) {
        this._updateHistoryState(variant);
      }
    },

    /**
     * Trigger event when variant image changes
     *
     * @param  {object} variant - Currently selected variant
     * @return {event}  variantImageChange
     */
    _updateImages: function(variant) {
      var variantImage = variant.featured_image || {};
      var currentVariantImage = this.currentVariant.featured_image || {};

      if (!variant.featured_image || variantImage.src === currentVariantImage.src) {
        return;
      }

      this.$container.trigger({
        type: 'variantImageChange',
        variant: variant
      });
    },

    /**
     * Trigger event when variant price changes.
     *
     * @param  {object} variant - Currently selected variant
     * @return {event} variantPriceChange
     */
    _updatePrice: function(variant) {
      if (variant.price === this.currentVariant.price && variant.compare_at_price === this.currentVariant.compare_at_price) {
        return;
      }

      this.$container.trigger({
        type: 'variantPriceChange',
        variant: variant
      });
    },

    /**
     * Update history state for product deeplinking
     *
     * @param {object} variant - Currently selected variant
     */
    _updateHistoryState: function(variant) {
      if (!history.replaceState || !variant) {
        return;
      }

      var newurl = window.location.protocol + '//' + window.location.host + window.location.pathname + '?variant=' + variant.id;
      window.history.replaceState({path: newurl}, '', newurl);
    },

    /**
     * Update hidden master select of variant change
     *
     * @param {object} variant - Currently selected variant
     */
    _updateMasterSelect: function(variant) {
      $(this.originalSelectorId, this.$container)[0].value = variant.id;
    }
  });

  return Variants;
})();


/*================ Sections ================*/
/**
 * Product Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Product template.
 *
   * @namespace product
 */

theme.Product = (function() {

  var selectors = {
    addToCart: '[data-add-to-cart]',
    addToCartText: '[data-add-to-cart-text]',
    comparePrice: '[data-compare-price]',
    comparePriceText: '[data-compare-text]',
    originalSelectorId: '[data-product-select]',
    priceWrapper: '[data-price-wrapper]',
    productFeaturedImage: '[data-product-featured-image]',
    productJson: '[data-product-json]',
    productPrice: '[data-product-price]',
    productThumbs: '[data-product-single-thumbnail]',
    singleOptionSelector: '[data-single-option-selector]'
  };

  /**
   * Product section constructor. Runs on page load as well as Theme Editor
   * `section:load` events.
   * @param {string} container - selector for the section container DOM element
   */
  function Product(container) {
    this.$container = $(container);

    // Stop parsing if we don't have the product json script tag when loading
    // section in the Theme Editor
    if (!$(selectors.productJson, this.$container).html()) {
      return;
    }

    var sectionId = this.$container.attr('data-section-id');
    this.productSingleObject = JSON.parse($(selectors.productJson, this.$container).html());

    var options = {
      $container: this.$container,
      enableHistoryState: this.$container.data('enable-history-state') || false,
      singleOptionSelector: selectors.singleOptionSelector,
      originalSelectorId: selectors.originalSelectorId,
      product: this.productSingleObject
    };

    this.settings = {};
    this.namespace = '.product';
    this.variants = new slate.Variants(options);
    this.$featuredImage = $(selectors.productFeaturedImage, this.$container);

    this.$container.on('variantChange' + this.namespace, this.updateAddToCartState.bind(this));
    this.$container.on('variantPriceChange' + this.namespace, this.updateProductPrices.bind(this));

    if (this.$featuredImage.length > 0) {
      this.settings.imageSize = slate.Image.imageSize(this.$featuredImage.attr('src'));
      slate.Image.preload(this.productSingleObject.images, this.settings.imageSize);

      this.$container.on('variantImageChange' + this.namespace, this.updateProductImage.bind(this));
    }
  }

  Product.prototype = $.extend({}, Product.prototype, {

    /**
     * Updates the DOM state of the add to cart button
     *
     * @param {boolean} enabled - Decides whether cart is enabled or disabled
     * @param {string} text - Updates the text notification content of the cart
     */
    updateAddToCartState: function(evt) {
      var variant = evt.variant;

      if (variant) {
        $(selectors.priceWrapper, this.$container).removeClass('hide');
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.unavailable);
        $(selectors.priceWrapper, this.$container).addClass('hide');
        return;
      }

      if (variant.available) {
        $(selectors.addToCart, this.$container).prop('disabled', false);
        $(selectors.addToCartText, this.$container).html(theme.strings.addToCart);
      } else {
        $(selectors.addToCart, this.$container).prop('disabled', true);
        $(selectors.addToCartText, this.$container).html(theme.strings.soldOut);
      }
      
    },

    /**
     * Updates the DOM with specified prices
     *
     * @param {string} productPrice - The current price of the product
     * @param {string} comparePrice - The original price of the product
     */
    updateProductPrices: function(evt) {
      var variant = evt.variant;
      var $comparePrice = $(selectors.comparePrice, this.$container);
      var $compareEls = $comparePrice.add(selectors.comparePriceText, this.$container);

      $(selectors.productPrice, this.$container)
        .html(slate.Currency.formatMoney(variant.price, theme.moneyFormat));

      if (variant.compare_at_price > variant.price) {
        $comparePrice.html(slate.Currency.formatMoney(variant.compare_at_price, theme.moneyFormat));
        $compareEls.removeClass('hide');
      } else {
        $comparePrice.html('');
        $compareEls.addClass('hide');
      }
    },

    /**
     * Updates the DOM with the specified image URL
     *
     * @param {string} src - Image src URL
     */
    updateProductImage: function(evt) {
      var variant = evt.variant;
      var sizedImgUrl = slate.Image.getSizedImageUrl(variant.featured_image.src, this.settings.imageSize);

      this.$featuredImage.attr('src', sizedImgUrl);
    },

    /**
     * Event callback for Theme Editor `section:unload` event
     */
    onUnload: function() {
      this.$container.off(this.namespace);
    }
  });

  return Product;
})();


/*================ Templates ================*/
/**
 * Customer Addresses Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Customer Addresses
 * template.
 *
 * @namespace customerAddresses
 */

theme.customerAddresses = (function() {
  var $newAddressForm = $('#AddressNewForm');

  if (!$newAddressForm.length) {
    return;
  }

  // Initialize observers on address selectors, defined in shopify_common.js
  if (Shopify) {
    new Shopify.CountryProvinceSelector('AddressCountryNew', 'AddressProvinceNew', {
      hideElement: 'AddressProvinceContainerNew'
    });
  }

  // Initialize each edit form's country/province selector
  $('.address-country-option').each(function() {
    var formId = $(this).data('form-id');
    var countrySelector = 'AddressCountry_' + formId;
    var provinceSelector = 'AddressProvince_' + formId;
    var containerSelector = 'AddressProvinceContainer_' + formId;

    new Shopify.CountryProvinceSelector(countrySelector, provinceSelector, {
      hideElement: containerSelector
    });
  });

  // Toggle new/edit address forms
  $('.address-new-toggle').on('click', function() {
    $newAddressForm.toggleClass('hide');
  });

  $('.address-edit-toggle').on('click', function() {
    var formId = $(this).data('form-id');
    $('#EditAddress_' + formId).toggleClass('hide');
  });

  $('.address-delete').on('click', function() {
    var $el = $(this);
    var formId = $el.data('form-id');
    var confirmMessage = $el.data('confirm-message');
    if (confirm(confirmMessage || 'Are you sure you wish to delete this address?')) {
      Shopify.postLink('/account/addresses/' + formId, {parameters: {_method: 'delete'}});
    }
  });
})();

/**
 * Password Template Script
 * ------------------------------------------------------------------------------
 * A file that contains scripts highly couple code to the Password template.
 *
 * @namespace password
 */

theme.customerLogin = (function() {
  var config = {
    recoverPasswordForm: '#RecoverPassword',
    hideRecoverPasswordLink: '#HideRecoverPasswordLink'
  };

  if (!$(config.recoverPasswordForm).length) {
    return;
  }

  checkUrlHash();
  resetPasswordSuccess();

  $(config.recoverPasswordForm).on('click', onShowHidePasswordForm);
  $(config.hideRecoverPasswordLink).on('click', onShowHidePasswordForm);

  function onShowHidePasswordForm(evt) {
    evt.preventDefault();
    toggleRecoverPasswordForm();
  }

  function checkUrlHash() {
    var hash = window.location.hash;

    // Allow deep linking to recover password form
    if (hash === '#recover') {
      toggleRecoverPasswordForm();
    }
  }

  /**
   *  Show/Hide recover password form
   */
  function toggleRecoverPasswordForm() {
    $('#RecoverPasswordForm').toggleClass('hide');
    $('#CustomerLoginForm').toggleClass('hide');
  }

  /**
   *  Show reset password success message
   */
  function resetPasswordSuccess() {
    var $formState = $('.reset-password-success');

    // check if reset password form was successfully submited.
    if (!$formState.length) {
      return;
    }

    // show success message
    $('#ResetSuccess').removeClass('hide');
  }
})();


$(document).ready(function() {
  var sections = new slate.Sections();
  sections.register('product', theme.Product);

  // Common a11y fixes
  //slate.a11y.pageLinkFocus($(window.location.hash));

  $('.in-page-link').on('click', function(evt) {
    slate.a11y.pageLinkFocus($(evt.currentTarget.hash));
  });

  // Target tables to make them scrollable
  var tableSelectors = '.rte table';

  slate.rte.wrapTable({
    $tables: $(tableSelectors),
    tableWrapperClass: 'rte__table-wrapper',
  });

  // Target iframes to make them responsive
  var iframeSelectors =
    '.rte iframe[src*="youtube.com/embed"],' +
    '.rte iframe[src*="player.vimeo"]';

  slate.rte.wrapIframe({
    $iframes: $(iframeSelectors),
    iframeWrapperClass: 'rte__video-wrapper'
  });

  // Apply a specific class to the html element for browser support of cookies.
  if (slate.cart.cookiesEnabled()) {
    document.documentElement.className = document.documentElement.className.replace('supports-no-cookies', 'supports-cookies');
  }

 
  // jQuery(function() {
  //   jQuery('.swatch :radio').change(function() {
  //     var optionIndex = jQuery(this).closest('.swatch').attr('data-option-index');
  //     var optionValue = jQuery(this).val();

  //     // When a variation label (sizes/ages in this case) is clicked, the
  //     // associated radio input changes. We then need to update the hidden
  //     // select (with the product variant IDs) and trigger a change event on that
  //     // select. So that the correct variation is added to the basket when
  //     // add to basket is clicked.
  //     // We do this by comparing the hidden select options text with the radio
  //     // input value. Because refactoring the markup will take longer.
  //     jQuery(this).closest('form').find('select option').each(function(i, el) {
  //       if (jQuery(el).text().trim() === optionValue) {
  //         jQuery('#id option').prop('selected', false);
  //         jQuery(el).prop('selected', true);
  //         jQuery('#id').trigger('change');

  //         // Fetch the in stock amount for the product variation.
  //         var productHandle = $('#product-handle').val();
  //         var productVariantId = parseInt(jQuery(el).val(), 10);

  //         $.getJSON('/products/' + productHandle + '.js', function(product) {
  //           if (product.variants.length) {
  //             for (var i = 0; i < product.variants.length; i++) {
  //               if (product.variants[i].id === productVariantId) {
  //                 if (product.variants[i].hasOwnProperty('inventory_quantity')) {
  //                   $('#instock').text(product.variants[i].inventory_quantity);
  //                 }
  //               }
  //             }
  //           }
  //         });
  //       }
  //     });

  //   });
  // });

  $('.usp-bar ul').on('init', function(event, slick){
      $(this).addClass('loaded');
  });

  $('.usp-bar ul').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false,
    autoplay: true,
    fade: true,
    autoplaySpeed: 2250,
    speed: 300,
    cssEase: 'linear',
    nextArrow: '<i class="ca-arrow-right"></i>',
    prevArrow: '<i class="ca-arrow-left"></i>'
  });

  $('#leading-categories ul').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    nextArrow: '<span class="svg-icon chevron-right"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M8.59,16.58L13.17,12L8.59,7.41L10,6L16,12L10,18L8.59,16.58Z" /></svg></span>',
    prevArrow: '<span class="svg-icon chevron-left"><svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" version="1.1" width="24" height="24" viewBox="0 0 24 24"><path d="M15.41,16.58L10.83,12L15.41,7.41L14,6L8,12L14,18L15.41,16.58Z" /></svg></span>',
    arrows:false,
    responsive: [
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2,
          autoplay: true,
          arrows:false,
          dots: true
        }
      }
      // You can unslick at a given breakpoint now by adding:
      // settings: "unslick"
      // instead of a settings object
    ]
  });

//   $(document).ready(function(){
//     if ($(window).width() > 760 ) {
//     $('.ex1').zoom();
//     }
//   });

  $('.klarna-banner').slick({
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true
  });
  $('.our-picks ul').slick({
    infinite: true,
    slidesToShow: 3,
    slidesToScroll: 1,
    autoplay: true,
    responsive: [
      {
        breakpoint: 860,
        settings: {
          slidesToShow: 2
        }
      },
	  {
		  breakpoint: 650,
		  settings: {
			slidesToShow: 1
		  }
      }
    ]
  });
  $('.main-banner ul').slick({
    infinite: false,
    slidesToShow: 1,
    slidesToScroll: 1,
    vertical: true,
    centerMode: true,
    centerPadding: 0,
    edgeFriction: 0,
    verticalSwiping: true,
    autoplay: true,
    dots: true,
    arrows: false,
    appendDots: '.dots-main',
    adaptiveHeight: false,
    cssEase: 'linear',
    responsive: [
      {
        breakpoint: 990,
        settings: {
          vertical: false,
          verticalSwiping: false,
        }
      }
    ]
  });

  $('.accordion').accordion({
    defaultOpen: 'section1',
    cookieName: 'accordion_nav',
    speed: 200
  });

  $(".footer-links .grid__item h2").click(function(){
      $(this).parent().toggleClass('open');
	  $(this).next("ul").slideToggle();
	  //$('html, body').animate({ scrollTop: $(this).offset().top - 170 }, 500 );
  });


      $(function() {
        // This button will increment the value
         $('.qtyplus').click(function(e){
             // Stop acting like a button
             e.preventDefault();
             // Get the field name
             fieldName = $(this).attr('field');
             // Get its current value
             var currentVal = parseInt($('input[id='+fieldName+']').val());
             // If is not undefined
             if (!isNaN(currentVal)) {
                 // Increment
                 $('input[id='+fieldName+']').val(currentVal + 1);
             } else {
                 // Otherwise put a 0 there
                 $('input[id='+fieldName+']').val(0);
             }
             $('.cart__update-btn').trigger('click');
         });
         // This button will decrement the value till 0
         $(".qtyminus").click(function(e) {
             // Stop acting like a button
             e.preventDefault();
             // Get the field name
             fieldName = $(this).attr('field');
             // Get its current value
             var currentVal = parseInt($('input[id='+fieldName+']').val());
             // If it isn't undefined or its greater than 0
             if (!isNaN(currentVal) && currentVal > 0) {
                 // Decrement one
                 $('input[id='+fieldName+']').val(currentVal - 1);
             } else {
                 // Otherwise put a 0 there
                 $('input[id='+fieldName+']').val(0);
             }
             $('.cart__update-btn').trigger('click');
         });

      });



		$('#primary-navigation').infinitypush({
			openingspeed: 300,
			closingspeed: 300
		});

    $('.slick-slide').eq(1).addClass('slick-second');


    $(".product-page .product-images .product-thumbnails li img").click(function(){

      var featuredimage = $(this).attr('src')

      $(".product-page .product-images .featured-image img.slick-current").attr('src', featuredimage);
    });

    var stickyBottomOffset = $('.main-footer').height();
    var stickyTopOffset = $('.header').height();
  $(".header").sticky({topSpacing:0, zIndex: 100, bottomSpacing:409});
  
  $('.header').on('sticky-start', function() { 
//     $('.ma-infinitypush-button').css('top','18px'); 
    $('.algolia-autocomplete').addClass( 'algolia-autocomplete-active' );
  });
  
  $('.header').on('sticky-end', function() { 
//     $('.ma-infinitypush-button').css('top','18px');  
    $('.algolia-autocomplete').removeClass( 'algolia-autocomplete-active' );
  });
  
  
  
  
  $('.search-form .search-terms').keyup(function () {
    if ($(this).val() == '') {
        $('.search-form .btn').prop('disabled', true);
    } else {
        $('.search-form .btn').prop('disabled', false);
    }
}).keyup();
  
  
  
  
  
    if ($(window).width() > 960) {
      $(".collection .sticky-content").sticky({topSpacing:70});
    }


  	$('.sort-action').click(function(e){
  		e.preventDefault();
  		$('#bc-sf-filter-top-sorting').slideToggle();
  	});


    $(document).on("click", ".filter-action",function() {
  		$('.category-filters').slideToggle();
    });

    $(document).on("click", ".collection .ais-page .collection-left-sidebar ul.action-links li.sort-action",function() {
          $('.ais-sort').slideToggle();
    });

  
	/**
	 * Cookies
	 * ------------------------------------------------------------------------------
	 * Set a cookie when changing page view on collections.
	 *
	 */

	//create Cookie
	function setCookie(name,value,days) {
		var expires = "";
		if (days) {
			var date = new Date();
			date.setTime(date.getTime() + (days*24*60*60*1000));
			expires = "; expires=" + date.toUTCString();
		}
		document.cookie = name + "=" + (value || "")  + expires + "; path=/";
	}

	//Get cookie value
	function getCookie(name) {
		var nameEQ = name + "=";
		var ca = document.cookie.split(';');
		for(var i=0;i < ca.length;i++) {
			var c = ca[i];
			while (c.charAt(0)==' ') c = c.substring(1,c.length);
			if (c.indexOf(nameEQ) == 0) return c.substring(nameEQ.length,c.length);
		}
		return null;
	}

	//Delete cookie
	function eraseCookie(name) {
		document.cookie = name+'=; expires=Thu, 01 Jan 1970 00:00:00 UTC; path=/';
	}

	/*BG: The purpose of these functions is to remember the view the user selects on the collections
	 page by setting a cookie, when selecting the second option.*/

	function changeCollectionView() {
	  //Retrieve cookie
	  var vCookie = getCookie('collectionsGrid'),
		  productCount = $('#bc-sf-filter-products.grid--uniform .grid__item').length;

	  //if it exists and there is more than 3 products, apply classes and remove old ones.
	  if (vCookie && productCount > 3) {
		//remove three column classes and apply four column classes
		$('#bc-sf-filter-products.grid--uniform .grid__item').removeClass('four-twelfths medium-up--four-twelfths');
		$('#bc-sf-filter-products.grid--uniform .grid__item').addClass('three-twelfths medium-up--three-twelfths');

		//remove active from grid1 and apply to grid2
		$('.list-style-links .grid2').addClass('active');
		$('.list-style-links .grid1').removeClass('active');
	  }
	}

	//run the code after everything has loaded.
	$(window).load(function(){
		changeCollectionView();
	});

  	$('.list-style-links .grid1').click(function(e){
  		e.preventDefault();
      $('.list-style-links li').removeClass("active");
      $(this).addClass("active");
      $('#bc-sf-filter-products .grid__item').addClass("four-twelfths");
      $('#bc-sf-filter-products .grid__item').addClass("medium-up--four-twelfths");
      $('#bc-sf-filter-products .grid__item').removeClass("three-twelfths");
      $('#bc-sf-filter-products .grid__item').removeClass("medium-up--three-twelfths");

	  //delete cookie when selecting original option
	  eraseCookie('collectionsGrid');
  	});

  	$('.list-style-links .grid2').click(function(e){
  		e.preventDefault();
      $('.list-style-links li').removeClass("active");
      $(this).addClass("active");
      $('#bc-sf-filter-products .grid__item').removeClass("four-twelfths");
      $('#bc-sf-filter-products .grid__item').removeClass("medium-up--four-twelfths");
      $('#bc-sf-filter-products .grid__item').addClass("three-twelfths");
      $('#bc-sf-filter-products .grid__item').addClass("medium-up--three-twelfths");

		//create a cookie
		setCookie('collectionsGrid','four', 365);
  	});

  	$('.size-country-list li').click(function(e){
      $('.size-country-list li').removeClass("active");
      $(this).addClass("active");
  	});

    $('.sizeguide-conversion').hide();
    $('.sizeguide-conversion-link').click(function(e){
      $('.sizeguide-measuring-link').removeClass("active");
      $('.sizeguide-conversion-link').removeClass("active");
      $('.sizeguide-sizeguide-link').removeClass("active");
      $(this).addClass("active");
  		e.preventDefault();
      $('.sizeguide-conversion').toggle();
      $('.sizeguide-main').hide();
      $('.sizeguide-measuring').hide();
    });

    $('.sizeguide-measuring').hide();
    $('.sizeguide-measuring-link').click(function(e){
      $('.sizeguide-measuring-link').removeClass("active");
      $('.sizeguide-conversion-link').removeClass("active");
      $('.sizeguide-sizeguide-link').removeClass("active");
      $(this).addClass("active");
  		e.preventDefault();
      $('.sizeguide-measuring').toggle();
      $('.sizeguide-main').hide();
      $('.sizeguide-conversion').hide();
    });

    $('.sizeguide-sizeguide-link').click(function(e){
      $('.sizeguide-measuring-link').removeClass("active");
      $('.sizeguide-conversion-link').removeClass("active");
      $('.sizeguide-sizeguide-link').removeClass("active");
      $(this).addClass("active");
  		e.preventDefault();
      $('.sizeguide-main').show();
      $('.sizeguide-measuring').hide();
      $('.sizeguide-conversion').hide();
    });

    $('.usa-size-chart').hide();
    $('.europe-size-chart').hide();
    $('.russia-size-chart').hide();
    $('.japan-size-chart').hide();
    $('.italy-size-chart').hide();
    $('.australia-size-chart').hide();
    $('.size-charts').hide();

    $('.size-guide').click(function(){
      $('.size-charts').toggle();
      $('.generic-overlay').toggle();
      $(".main-nav").css("z-index","85");
      $(".header").css("z-index","85");
      $(".usp-bar").css("z-index","85");
    });

    $('.close-icon').click(function(){
      $('.size-charts').toggle();
      $('.generic-overlay').toggle();
      $(".main-nav").css("z-index","100");
      $(".header").css("z-index","100");
      $(".usp-bar").css("z-index","100");
    });

    $('.size-country-list li.usa-size').click(function(e){
      $('.usa-size-chart').show();
      $('.uk-size-chart').hide();
      $('.europe-size-chart').hide();
      $('.russia-size-chart').hide();
      $('.japan-size-chart').hide();
      $('.italy-size-chart').hide();
      $('.australia-size-chart').hide();
    });

    $('.size-country-list li.uk-size').click(function(e){
      $('.uk-size-chart').show();
      $('.usa-size-chart').hide();
      $('.europe-size-chart').hide();
      $('.russia-size-chart').hide();
      $('.japan-size-chart').hide();
      $('.italy-size-chart').hide();
      $('.australia-size-chart').hide();
    });

    $('.size-country-list li.europe-size').click(function(e){
      $('.europe-size-chart').show();
      $('.usa-size-chart').hide();
      $('.uk-size-chart').hide();
      $('.russia-size-chart').hide();
      $('.japan-size-chart').hide();
      $('.italy-size-chart').hide();
      $('.australia-size-chart').hide();
    });

    $('.size-country-list li.russia-size').click(function(e){
      $('.russia-size-chart').show();
      $('.usa-size-chart').hide();
      $('.uk-size-chart').hide();
      $('.europe-size-chart').hide();
      $('.japan-size-chart').hide();
      $('.italy-size-chart').hide();
      $('.australia-size-chart').hide();
    });

    $('.size-country-list li.japan-size').click(function(e){
      $('.japan-size-chart').show();
      $('.usa-size-chart').hide();
      $('.uk-size-chart').hide();
      $('.europe-size-chart').hide();
      $('.russia-size-chart').hide();
      $('.italy-size-chart').hide();
      $('.australia-size-chart').hide();
    });

    $('.size-country-list li.italy-size').click(function(e){
      $('.italy-size-chart').show();
      $('.usa-size-chart').hide();
      $('.uk-size-chart').hide();
      $('.europe-size-chart').hide();
      $('.russia-size-chart').hide();
      $('.japan-size-chart').hide();
      $('.australia-size-chart').hide();
    });

    $('.size-country-list li.australia-size').click(function(e){
      $('.australia-size-chart').show();
      $('.usa-size-chart').hide();
      $('.uk-size-chart').hide();
      $('.europe-size-chart').hide();
      $('.russia-size-chart').hide();
      $('.japan-size-chart').hide();
      $('.italy-size-chart').hide();
    });


    var productCode = $('.product-code').text();
    var afterWith = productCode.substr(0, productCode.lastIndexOf("-"));
    console.log("after (with \\)    : " + afterWith);
    $('.product-code').html(afterWith);


    if ($(window).width() > 1160) {
      $('.returns-page a').click(function(e){
        console.log('Desktop');
        $('.returns-left').css('margin-left','-50%');
        $('.returns-content').css('right','50px');
        $('.returns-content').css('left','auto');
        $('.returns-right').show();
      });

      $('.returns-policy-link').click(function(e){
    		e.preventDefault();
        $('.policy-content').show();
        $('.portal-content').hide();
        $('.returns-page .returns-left .returns-content ul li a').css('background','#FFFFFF');
        $('.returns-page .returns-left .returns-content ul li a').css('border','1px solid #FFFFFF');
        $('.returns-page .returns-left .returns-content h2').css('color','#FFFFFF');
        $(".returns-page .returns-left .returns-content ul li a").mouseenter(function() {
          $(this).css("color", "#000");
        }).mouseleave(function() {
          $(this).css("color", "#000");
        });
      });
    }


    if ($(window).width() < 1160) {
      $('.returns-page a').click(function(e){
        console.log('Mobile');
        $('.returns-right').show();
        $('.returns-right').removeClass('one-half');
        $('.returns-right').addClass('one-whole');
      });
      $('.returns-policy-link').click(function(e){
    		e.preventDefault();
        $('.policy-content').show();
        $('.portal-content').hide();
        $('.returns-right').css('margin-top','70px');
        $('html,body').animate({
           scrollTop: $("#returnsContent").offset().top
        });
      });
    }

   	function persistentCheck(target,targetValue,paramFunction,paramTarget,timeoutTime) {
   		//console.log('persistentCheckFunction');
   		var checkExist = setInterval(function() {
   			//console.log('Persistently checking for: '+target);
   			//keep checking to see if condition is true
   			if ($(target).length > targetValue) {
   				//console.log('condition is true, will no longer check.');
   				//check paramFunction is actually a function
   				if (typeof paramFunction == "function") {
   					paramFunction(paramTarget);
   				}
   				//clear interval
   				clearInterval(checkExist);
   			}
   		}, 100); // check every 100ms

   		setTimeout(function(){
   			//console.log('couldn\'t find target or condition wasn\'t true');
   			clearInterval(checkExist);
   		}, timeoutTime);
   	}


   function relatedProductsSlick(target) {
       $(target).slick({
         slidesToShow: 4,
         slidesToScroll: 1,
         infinite: true,
         arrows: false,
         responsive: [
           {
             breakpoint: 768,
             settings: {
               slidesToShow: 3,
             }
           },
           {
             breakpoint: 576,
             settings: {
               slidesToShow: 2,
             }
           }
        ]
     });
   }


	if ($('body.template-product')) {
		persistentCheck('.recomatic-product',5,relatedProductsSlick,'.related-products ul',10000);
  }

  
  
  
  
  $('.collection-sublinks ul').flickity({
    // options
    cellAlign: 'center',
    contain: true,
    prevNextButtons: false,
    pageDots: false
  });

//   $('.home-mobile-links ul').flickity({
//     // options
//     cellAlign: 'left',
//     contain: true,
//     prevNextButtons: false,
//     pageDots: false
//   });
  
  
  $('.country-flag').click(function() {
  
    var thisStore = location.hostname;
    var country = $(this).attr("data-country");
    var pathname = window.location.pathname;
    
    // console.log(country);
    // console.log(thisStore);
    // console.log(pathname);
    
    if (country == thisStore) {
      console.log(country);
    } else {
      window.location.assign("https://"+country+pathname) 
    }
  
  
  });
  
  
});

$(window).on('load', function() {
  
  var overlay = $('.generic-overlay');

  overlay.hide();
  
  $(".main-nav ul li").has(".subnav")
  .mouseover(function() {
    overlay.show();
  })
  .mouseout(function() {
    overlay.hide();
  });

});
